<div class="modal-header">
  <h4 class="modal-title pull-left">{{'chooseFinalizationAction.selection.generate.mcsgds.articleNo' | translate }}</h4>
  <button aria-label="Close" class="close pull-right" type="button" (click)="onCancel()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <p>{{'chooseFinalizationAction.selection.generate.mcsgds.articleNo.choice_action' | translate }}</p>
    <div class="pl-5">
      <div class="form-check">
        <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="false" [(ngModel)]="useDefaultSeries">
        <label class="form-check-label" for="radio1">{{ 'chooseFinalizationAction.selection.generate.mcsgds.articleNo.choice_article_series' | translate : {'0' : getPreviewGeneratedArticleNo()} }}</label>
      </div>
      <div class="form-check mt-4">
        <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="true" [(ngModel)]="useDefaultSeries">
        <label class="form-check-label" for="radio2">{{ 'chooseFinalizationAction.selection.generate.mcsgds.articleNo.choice_article_default_series' | translate: {'0' : getPreviewGeneratedArticleNo(false)} }}</label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="onCancel()">{{ 'global.label.close' | translate }}</button>
  <button class="btn btn-primary btn-forward" (click)="onConfirm()">{{'global.label.next' | translate}}</button>
</div>
